import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const footerHeight = 72;

export const styles = ({ spacing }: Theme) =>
  createStyles({
    footerWrapper: {
      backgroundColor: colors.white.lightest,
      borderTop: '1px solid #EAECF0',
      color: colors.grey.main,
      display: 'flex',
      flex: '0 0 auto',
      flexDirection: 'column',
      minHeight: footerHeight,
      justifyContent: 'center',
      maxWidth: 880,
      padding: spacing(4, 6),
      width: '100%',
      zIndex: 1,
    },
    footerActionsWrap: {},
    validationError: {
      color: '#B42318', //TODO replace after creating new palette
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: colors.grey.main,

      '&:hover': {
        color: colors.black.darkest,
      },
    },
    backIcon: {
      fontSize: 13,
      position: 'relative',
      bottom: 2,
      marginRight: spacing(1),
      marginTop: spacing(1),
      color: 'inherit',
    },
  });
